import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { BsCalendarEventFill, BsGearFill } from 'react-icons/bs';
import { ImNotification } from 'react-icons/im';
// import dayjs from 'dayjs';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { fetchWrapper } from '../_helpers/fetchWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { getUserData } from '../Redux/slices/user';
import { toast } from 'react-toastify';
import { ErrorMessageHandler } from '../_helpers/_methods';

function NotificationBar({ notification }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  let icon = <ImNotification color="#0d78f9" />;
  switch (notification.type) {
    case 'event':
      icon = <BsCalendarEventFill color={'#4aa746'} />;
      break;
    case 'system':
      icon = <BsGearFill color="#ffc23d" />;
      break;
    default:
  }

  const handleRoleChange = async () => {
    try {
      const title = notification.role;
      if (!title) return;
      if (title !== user.active_role) {
        await fetchWrapper.post('/switch-role/', {
          role: title
        });
        // changeActiveRole(title);
        toast.success(`Successfully changed role to ${title}`);
        dispatch(getUserData());
        navigate('/admin');
      }
    } catch (err) {
      ErrorMessageHandler(err);
    }
  };
  return (
    <StyledNotificationBar onClick={handleRoleChange}>
      <Link key={notification.id} to={notification?.redirect || notification?.redirect_url || '#'}>
        <div className="icon d-flex align-items-center">{icon}</div>
        <div className="notification-content">
          <div>{notification.text}</div>
          <div className="small d-flex align-items-center">
            {notification.type}
            <span className="ms-2 ">
              <AiOutlineClockCircle fontSize="12" className="me-1" />
              {/* {notification?.created_at && dayjs(new Date(notification.created_at))?.fromNow()} */}
            </span>
          </div>
        </div>
      </Link>
    </StyledNotificationBar>
  );
}

export default NotificationBar;

const StyledNotificationBar = styled.div`
  a {
    text-decoration: none !important;
    padding: 8px 14px;
    display: flex;
    border-radius: 5px;
    cursor: pointer;
    z-index: 10;
    &:hover {
      background-color: #ccc;
    }
    .icon {
      margin-right: 10px;
      svg {
        font-size: 25px;
      }
    }
  }
`;
